// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__r6DxF"};